import { getNodeConfig } from '../../../../api/workflows-steps/formSchema.tsx';
import { WorkflowNodeType } from '../../../../api/model.ts';
import { Draggable } from '@hello-pangea/dnd';
import { DraggableListItem, NodeRowCard } from '../Form.styles.tsx';
import TextField from '@mui/material/TextField';
import { DragIndicator } from '@mui/icons-material';

type NodeRowProps = {
  id: string;
  index: number;
  onColumnChange: (s: string, i: number) => void;
  column: string | null;
  name: string;
  type: WorkflowNodeType;
  disabled?: boolean;
};

const NodeDraggableRow = ({ id, index, name, type, onColumnChange, column, disabled }: NodeRowProps) => {
  const { color, icon } = getNodeConfig(type)!;
  return (
    <Draggable key={id} draggableId={id} index={index} isDragDisabled={disabled}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            marginBottom: '8px',
            ...provided.draggableProps.style,
          }}
        >
          <DraggableListItem
            className="grid grid-cols-1 gap-4 md:grid-cols-24 items-center"
            isDragging={snapshot.isDragging}
            color={color}
          >
            <NodeRowCard className="col-span-1" color={color}>
              {icon}
            </NodeRowCard>

            <div className="col-span-11 text-center">{name}</div>
            <div className="col-span-11">
              <TextField
                defaultValue={column}
                onChange={(event) => onColumnChange(event.target.value, index)}
                fullWidth
                variant="outlined"
                disabled={disabled}
              />
            </div>
            <div className="col-span-1 flex justify-end">{!disabled && <DragIndicator />}</div>
          </DraggableListItem>
        </div>
      )}
    </Draggable>
  );
};

export default NodeDraggableRow;
